/**
 * About 1037 — BDU "About <programme>"
 * Heading + gradient rule + justified copy + dotted keypoint chips, with the site's
 * inline lead form on the right from 768px up, and a full-width Enroll Now CTA below.
 */

export const ABOUT_1037_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Keypoint chips",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_alt: "",
    meta_title: "Finance",
    meta_priority: 1,
    meta_status: true,
  },

  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Heading",
      value: "About the programme",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. About Online MBA",
      defaultValue: "About the programme",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "description",
      label: "Body copy (blank lines are preserved)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Programme overview…",
      defaultValue: "",
      rows: 8,
    },
    {
      fieldName: "description_text_color",
      label: "Body / chip text colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "highlight_border_color",
      label: "Keypoint chip — dotted border",
      value: "#EF4444",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#EF4444",
    },
    {
      fieldName: "gradient_color_3",
      label: "Keypoint chip accent bar — start (768px and up)",
      value: "#FD0113",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FD0113",
    },
    {
      fieldName: "gradient_color_4",
      label: "Keypoint chip accent bar — end (768px and up)",
      value: "#9E0113",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9E0113",
    },
    {
      fieldName: "enable_lead_form",
      label: "Show the lead form (inline from 768px, CTA below)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "mobile_apply_now_text",
      label: "Mobile CTA label (below 768px, in place of the form)",
      value: "Enroll Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enroll Now",
      defaultValue: "Enroll Now",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (32x32)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Finance",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
